/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import React from 'react'
import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    List,
    Segment,
} from 'semantic-ui-react';
import { Link } from 'react-scroll';
import { openInNewTab } from '../util/util';
import ResponsiveContainer from './ResponsiveContainer';
import FacebookFrame from './FacebookFrame';
import LocalImage from './LocalImage';

import classic from '../images/classic.jpg';
import garlic from '../images/garlic.jpg';
import nut_set from '../images/nut_set.jpg';
import nut_logo from '../images/nut_logo.jpg';

const HomepageLayout = () => (
    <ResponsiveContainer>
        <Segment style={{ padding: '8em 0em' }} vertical>
            <Container text>
                <LocalImage
                    alt="nut_logo"
                    src={nut_logo}
                />
            </Container>
        </Segment>

        <Segment style={{ padding: '8em 0em' }} vertical>
            <a id="posts"></a>
            <Grid container stackable verticalAlign='middle'>
                <Grid.Row>
                    <Grid.Column width={5}>
                        <FacebookFrame title="fb_1" post="170516604783565" />
                    </Grid.Column>
                    <Grid.Column width={5}>
                        <FacebookFrame title="fb_2" post="114202843748275" />
                    </Grid.Column>
                    <Grid.Column width={5}>
                        <FacebookFrame title="fb_3" post="131545815347311" />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column textAlign='center'>
                        <Button
                            size='huge'
                            onClick={() => openInNewTab("https://www.facebook.com/trinutspampanga")}>
                                More Posts
                        </Button>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>

        <Segment style={{ padding: '0em' }} vertical>
            <Divider
                    as='h4'
                    className='header'
                    horizontal
                    style={{ margin: '3em 0em', textTransform: 'uppercase' }}
            >
                <a id="products">Products</a>
            </Divider>
            <Grid celled='internally' columns='equal' stackable>
                <Grid.Row textAlign='center'>
                    <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                        <Header as='h3' style={{ fontSize: '2em' }}>
                            Classic
                        </Header>
                        <LocalImage
                            alt="classic"
                            src={classic}
                        />
                    </Grid.Column>
                    <Grid.Column style={{ paddingBottom: '5em', paddingTop: '5em' }}>
                        <Header as='h3' style={{ fontSize: '2em' }}>
                            Garlic
                        </Header>
                        <LocalImage
                            alt="garlic"
                            src={garlic}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>

        <Segment style={{ padding: '8em 0em' }} vertical>
            <Container text>
                <LocalImage
                    alt="nut_set"
                    src={nut_set}
                />
                <Divider
                    as='h4'
                    className='header'
                    horizontal
                    style={{ margin: '3em 0em', textTransform: 'uppercase' }}
                >
                    <a id="contact">Get in Touch</a>
                </Divider>
            <p style={{ fontSize: '1.33em' }}>
                <i class="phone icon"></i>
                <a href="tel:+639066296875">0906-629-6875</a> <br />
                <i class="mail icon"></i>
                <a href="mailto:trinutspampanga@m.com">trinutspampanga@gmail.com</a> <br/>
                <i class="facebook icon"></i>
                <a href="https://www.facebook.com/trinutspampanga" target="_blank" rel="noopener noreferrer">fb.com/trinutspampanga</a> <br />
                <i class="google icon"></i>
                <a href="https://g.page/trinuts" target="_blank" rel="noopener noreferrer">g.page/trinuts</a> <br />
                {/* <i class="map marker alternate icon"></i>
                73 Masagana Street, Sindalan, City of San Fernando, Pampanga 2000 <br /> */}
                <i class="map marker alternate icon"></i>
                Near the Sindalan Barangay Hall, just at the back of the basketball court <br/>
            </p>
            <div className="ui frame">
                <iframe
                    title="mymaps"
                    src="https://www.google.com.au/maps/d/embed?mid=1MhLN0LkrNFyE6WQuQiMvvtNYQ0LZ-n37"
                    width="100%"
                    height="400">
                </iframe>
            </div>
            
            </Container>
        </Segment>

        <Segment inverted vertical style={{ padding: '5em 0em' }}>
            <Container>
                <Grid divided inverted stackable>
                    <Grid.Row>
                        <Grid.Column width={3}>
                            <Header inverted as='h4' content='About' />
                            <List link inverted>
                                <div>
                                    <List.Item as='who_we_are'>
                                        <Link
                                            to="top"
                                            smooth={true}
                                            duration={1000}
                                        >Who we are</Link>
                                    </List.Item>
                                </div>
                            </List>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <Header inverted as='h4' content='Services' />
                            <List link inverted>
                                <List.Item as='contact_us'>
                                    <div>
                                        <Link
                                            to="contact"
                                            smooth={true}
                                            duration={1000}
                                        >Contact Us</Link>
                                    </div>
                                </List.Item>
                            </List>
                        </Grid.Column>
                        <Grid.Column width={7}>
                            <Header as='h4' inverted>
                            <a href="https://www.facebook.com/trinutspampanga" target="_blank" rel="noopener noreferrer">Trinuts Pampanga</a>
              </Header>
                            <p>
                                Choose to eat healthy. Get your Trinuts Baked Peanuts today.
              </p>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        </Segment>
    </ResponsiveContainer>
)

export default HomepageLayout